import React from 'react';
import { STATUS_LABELS } from '../config/cashFlowBenchmarkConfig';
import '../styles/ChartModal.css';

export const STATUS_ICONS = {
    strong: '●',
    watch: '▲',
    weak: '■',
    notApplicable: '○',
    insufficientData: '◌',
    diagnosticOnly: '◆',
    selfFunded: '●',
    externallyFunded: '▲',
};

export default function CashFlowStatusBadge({ status, label }) {
    const resolvedLabel = label || STATUS_LABELS[status] || status;
    const icon = STATUS_ICONS[status] || '●';
    return (
        <span className={`fin-bench-status fin-bench-status--${status || 'insufficientData'}`}>
            <span className="fin-bench-status-icon" aria-hidden="true">{icon}</span>
            <span>{resolvedLabel}</span>
        </span>
    );
}
